import { CreateVideo, DownloadRecordedRequest, StaticVideo, VideoCaption } from "../types/working-model";
import { Get, GetJson, Post, PostJson, PutJson } from "./helpers";

export function UpdateStaticVideo(token: string, video: StaticVideo): Promise<StaticVideo> {
	return PutJson({
		path: `/v4/videos/channel/${video.channel}/videos/${video.uuid}`,
		token,
		data: video
	});
}


export function UploadedVideo(token: string, video: CreateVideo | StaticVideo, channel: number): Promise<StaticVideo> {
	return PostJson({
		path: `/v4/videos/channel/${channel}/video`,
		token,
		data: video
	});
}

export function GetChannelVideos(token: string, channel: number): Promise<StaticVideo[]> {
	return Get(`/v4/videos/channel/${channel}/uploaded`, token);
}

export function GetRecordedVideos(token: string, channel: number): Promise<any> {
	return Get(`/v4/videos/channel/${channel}/recorded`, token);
}

export function GetPendingDownloadRequests(token: string, channel: number): Promise<DownloadRecordedRequest[]> {
	return GetJson({
		path: `/v4/videos/channel/${channel}/recorded/downloads/pending`,
		token,
	});
}


export function GetRecordedVideoDownload(token: string, videoUuid: string, channel: number, forceFailure?: boolean): Promise<DownloadRecordedRequest> {
	return GetJson({
		path: `/v4/videos/channel/${channel}/recorded/${videoUuid}/download`,
		token,
	});
}

export function DeleteVideos(videoUuids: string[], token: string, channel: number): Promise<any> {
	return Post(`/v4/videos/channel/${channel}/videos/delete`, token, { videoUuids });

}

export function GetRecordedMuxVideoDownload(token: string, videoUuid: string, channel: number): Promise<DownloadRecordedRequest> {
	return Get(`/v3/admin/channel/videos/recorded/download/mux/${videoUuid}/${channel}`, token);
}

export function GetVideoCaptions(token: string, channelId: number, videoUuid: string): Promise<VideoCaption[]> {
	return GetJson({
		path: `/v4/videos/channel/${channelId}/videos/${videoUuid}/captions`,
		token
	});
}

type AddVideoCaptionFileInput = {
	token: string,
	channel: number,
	s3Url: string,
	fileName: string,
	language: string,
	videoId?: number,
	recordingId?: number
}

type AddStaticVideoCaptionFileInput = {
	token: string,
	channel: number,
	videoCaption: Partial<VideoCaption>
}

export function AddStaticVideoCaptionFile({ token, channel, videoCaption }: AddStaticVideoCaptionFileInput): Promise<void> {
	return PostJson({
		path: `/v4/videos/channel/${channel}/videos/${videoCaption.static_video_uuid}/caption`,
		token,
		data: videoCaption,
	});
}

export function UpdateVideoCaptionFileSource(token: string, channel: number, videoCaption: VideoCaption): Promise<void> {
	return PutJson({
		path: `/v4/videos/channel/${channel}/videos/${videoCaption.static_video_uuid}/caption`,
		token,
		data: videoCaption,
	});
}

export function UpdateVideoName(token: string, video: StaticVideo, newName: string): Promise<any> {
	return PutJson({
		path: `/v4/videos/channel/${video.channel}/videos/${video.uuid}/name`,
		token,
		data :{ newName }
	});
}

export function getVideo(token: string, channel: number, videoUuid: string): Promise<StaticVideo> {
	return GetJson({
		path: `/v4/videos/channel/${channel}/videos/${videoUuid}`,
		token,
	});
}
